export default __webpack_public_path__ + "static/media/spent.f89495b5.svg";